import { render } from "./BandLogo.vue?vue&type=template&id=00b24b27&scoped=true"
import script from "./BandLogo.vue?vue&type=script&lang=js"
export * from "./BandLogo.vue?vue&type=script&lang=js"

import "./BandLogo.vue?vue&type=style&index=0&id=00b24b27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b24b27"]])

export default __exports__